var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-to-top",class:{ 'show': _vm.goTopShow },on:{"click":_vm.goTop}},[_c('i',{staticClass:"icon-chevron-down"})])}
var staticRenderFns = []

export { render, staticRenderFns }